import { AlertListTypeEnum } from '../../../utilities/Constants';
import { IAlertSearchModel } from '../../../interfaces/INote';
import { useQuery } from 'react-query';
import { useZoneContext } from '../../../contexts/useZoneContext';

export const useGetAlerts = (
    searchModel: IAlertSearchModel,
    alertListType: AlertListTypeEnum,
    enabled: boolean
) => {
    const { zoneApiClient } = useZoneContext();
    return useQuery({
        queryKey: ['get-alerts', alertListType],
        queryFn: async () => {
            const response = await zoneApiClient.searchAlerts(searchModel);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve alerts.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        enabled,
        cacheTime: 0,
        staleTime: 0,
    });
};
